import i18next from 'i18next';
import { toast } from "sonner";
import { useGapStore } from "../../store/gap.store.js";
import { useTenantStore } from "../../store/tenant.store.js";
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class GapIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchAll(page = 1, pageSize = 10, search = "", sortBy = "", sortOrder = "desc", columnFilters = {}) {
        const store = useGapStore.getState();
        const tenantId = useTenantStore.getState().selectedTenantId;
        store.setLoading(true);
        store.clearError();
        if (!tenantId) {
            store.setLoading(false);
            return { success: false, error: "Tenant context required" };
        }
        try {
            const response = await this.service.getAll({
                page,
                pageSize,
                search,
                sortBy,
                sortOrder,
                tenantId,
                ...Object.entries(columnFilters).reduce((acc, [key, value]) => {
                    if (value && value.length > 0) acc[`filter_${key}`] = value;
                    return acc;
                }, {}),
            });
            const { data, pagination, uniqueValues } = response;
            store.setGaps(data || []);
            if (pagination) {
                store.setPaginationData({
                    currentPage: pagination.page,
                    totalPages: pagination.totalPages,
                    totalItems: pagination.total,
                    itemsPerPage: pagination.pageSize,
                });
            }
            if (uniqueValues) store.setUniqueValues(uniqueValues);
            return { success: true };
        } catch (error) {
            const msg = getIntegrationErrorMessage(error) || i18next.t('integrationToasts:couldNotLoadList', { defaultValue: "Could not load list" });
            store.setError(msg);
            toast.error(msg);
            return { success: false, error: msg };
        } finally {
            store.setLoading(false);
        }
    }

    async update(id, data) {
        const store = useGapStore.getState();
        store.setLoading(true);
        try {
            const response = await this.service.update(id, data);
            toast.success(i18next.t('integrationToasts:recordUpdated', { defaultValue: "Record updated" }));
            return { success: true, data: response.data };
        } catch (error) {
            const msg = getIntegrationErrorMessage(error) || i18next.t('integrationToasts:couldNotUpdateRecord', { defaultValue: "Could not update record" });
            toast.error(msg);
            return { success: false, error: msg };
        } finally {
            store.setLoading(false);
        }
    }
}
